import { TrailerEntity } from "@ots-frontend/ots-data";
import React from "react";
import { EntityMarkerClusterer, EntityMarkerClusterProps } from "../EntityMarkerCluster/EntityMarkerCluster";
import { isEqual } from "lodash";

export type TrailerMarkerClustererProps = EntityMarkerClusterProps<TrailerEntity>

export const TrailerMarkerClusterer = (props: TrailerMarkerClustererProps) => {
  const { ...rest } = props;

  return (
    <EntityMarkerClusterer {...rest} />
  );
};

export const TrailerMarkerClustererMemo = React.memo(
  TrailerMarkerClusterer,
  isEqual
);
